import { logger } from '../../../shared/logger';
import { LOGS_KEY } from '../../constants';
import { markGigsAsChoice } from './helpers';

export const choiceBadgeEnrichment = async ({
    abTests = {},
    recentlyViewedChoiceGigs = [],
    choiceAlgos = {},
    componentData,
}) => {
    try {
        if (!recentlyViewedChoiceGigs || !choiceAlgos) {
            return componentData;
        }

        const {
            name,
            properties,
            items: { gigs },
        } = componentData;
        const { gigs: gigsProperties } = properties;
        const algoTypes = choiceAlgos[name];

        if (!algoTypes) {
            return componentData;
        }

        const { hasChoiceEnrichment, enrichedGigs } = markGigsAsChoice({
            gigs,
            gigsProperties,
            abTests,
            recentlyViewedChoiceGigs,
            algoTypes,
        });

        if (!hasChoiceEnrichment) {
            return componentData;
        }

        return {
            ...componentData,
            items: {
                ...componentData.items,
                gigs: enrichedGigs,
            },
        };
    } catch (error) {
        logger.error(error, { [LOGS_KEY]: 'Error in choiceBadgeEnrichment' });

        return componentData;
    }
};
